(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.overlayState = null;
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky = false;

      this.headerBounds = { top: 0, bottom: this.offsetHeight };
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.overlayEnabled = this.hasAttribute('data-overlay');
      this.overlayTarget = null;

      this.setHeaderHeight();

      this.onMatchMediaChange = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.mobileMedia = window.matchMedia('(max-width: 990px)');
      this.mobileMedia.addEventListener('change', this.onMatchMediaChange);
      window.addEventListener('resize', this.onMatchMediaChange);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (this.overlayEnabled) {
        const targetSelector = this.getAttribute('data-overlay-target') || 'main .shopify-section:first-child, .shopify-section:first-child';

        try {
          this.overlayTarget = document.querySelector(targetSelector);
        } catch (e) {
          this.overlayTarget = document.querySelector('main .shopify-section:first-child') || document.querySelector('.shopify-section:first-child');
        }
      }

      this.createObserver();
      this.overlayState = null;
      this.updateOverlayState(true);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onMatchMediaChange);
      this.mobileMedia.removeEventListener('change', this.onMatchMediaChange);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      this.headerBounds = { top: 0, bottom: this.offsetHeight };
      this.overlayState = null;
      this.updateOverlayState(true);
    }

    createObserver() {
      this.headerBounds = { top: 0, bottom: this.offsetHeight };
    }

    updateOverlayState(force = false) {
      if (!this.overlayEnabled || !this.overlayTarget) return false;

      const drawerOpen = this.querySelector('header-drawer details[open]') || this.querySelector('.header-side-drawer-menu__details[open]');
      if (drawerOpen) return false;

      const targetRect = this.overlayTarget.getBoundingClientRect();
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const buffer = 24;
      const shouldOverlay = targetRect.bottom > headerHeight + buffer;

      if (!force && shouldOverlay === this.overlayState) {
        return shouldOverlay;
      }

      this.overlayState = shouldOverlay;
      this.classList.toggle('is-overlay', shouldOverlay);
      this.classList.toggle('header-wrapper--overlay', shouldOverlay);

      return shouldOverlay;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const mobileDrawerOpen = this.querySelector('header-drawer details[open]');
      const sideDrawerOpen = this.querySelector('.header-side-drawer-menu__details[open]');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (mobileDrawerOpen || sideDrawerOpen) return;

      this.updateOverlayState();

      const scrollDelta = scrollTop - this.currentScrollTop;
      if (Math.abs(scrollDelta) < 4) return;

      if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.overlayState = null;
      this.updateOverlayState(true);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());

      this.sideDrawers = this.sideDrawers || this.header.querySelectorAll('.header-side-drawer-menu__details');
      this.sideDrawers.forEach((drawer) => drawer.removeAttribute('open'));
      document.body.classList.remove('header-side-drawer--open');

      this.header.classList.remove('side-drawer-open');

      const headerWrapper = this.header.querySelector('.header-wrapper');
      if (headerWrapper) headerWrapper.classList.remove('side-drawer-open');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
